<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('loadingProducts')">Carico</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Crea
    </h1>

    <div class="bg-white rounded-md shadow max-w-5xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 mb-8 flex flex-wrap">

          <text-input
            v-model="form.sku"
            :error="form.errors.sku"
            class="pr-6 pb-8 w-full lg:w-1/3"
            label="SKU"
          />

          <div class="w-full lg:w-1/3 pr-6 pb-8">
            <label class="form-label mb-1">Lotto</label>
            <multiselect
              v-model="selectedBatch"
              placeholder="Cerca lotto"
              label="nome"
              track-by="id"
              :options="batchResults"
              :searchable="true"
              :loading="isLoading"
              :internal-search="false"
              @search-change="fetchBatches"
              @input="onBatchSelected"
            />
          </div>

        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Crea Carico
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from 'vue-multiselect'
import axios from 'axios'

export default {
  metaInfo: { title: 'Crea Carico' },
  layout: Layout,

  components: {
    TextInput,
    LoadingButton,
    Multiselect,
  },

  props: {
    batches: Array, // ora è vuoto ma serve per Inertia
  },

  data() {
    return {
      selectedBatch: null,
      batchResults: [],
      isLoading: false,

      form: this.$inertia.form({
        sku: null,
        batch_id: null,
      }),
    }
  },

  methods: {
    store() {
      if (navigator.onLine) {
        this.form.post(this.route('loadingProducts.store')), this.form.reset('sku'), this.form.focus('sku')
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },

    fetchBatches(term) {
      if (!term || term.length < 2) {
        this.batchResults = []
        return
      }

      this.isLoading = true
      axios.get(this.route('api.batches.search'), {
        params: { term }
      })
      .then(res => {
        this.batchResults = res.data
        this.isLoading = false
      })
      .catch(() => {
        this.isLoading = false
      })
    },

    onBatchSelected(batch) {
      this.form.batch_id = batch?.id || null
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>